import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { clearAllAction, screenLoadingAction } from 'redux/actions'
import { registerAndLogin } from 'redux/reducers/apiReducers/registerReducer'
import { logoutAction } from 'redux/reducers/apiReducers/authenticationReducer'
import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
import axios from 'axios'
import moment from 'moment'

const PrivacyNoticeView = ({ t, i18n, setIsError }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [errMsg, setErrMsg] = useState('')
  const [outageRichText, setOutageRichText] = useState(null)
  const [outageStartDate, setOutageStartDate] = useState('')
  const [outageEndDate, setOutageEndDate] = useState('')
  const dateNow = moment().toDate()
  const outageUrl = window.location.origin + '/services/outageservice/api/outage-events'
  const [serviceFlag, setServiceFlag] = useState(false)
  const [dateFlag, setDateFlag] = useState(false)
  const [outageActive, setOutageActive] = useState(false)
  const [disableFlag, setDisableFlag] = useState(false)
  const [warningStartDate, setWarningStartDate] = useState('')
  const [warningEndDate, setWarningEndDate] = useState('')
  const [warningRichText, setWarningRichText] = useState(null)
  const [warningFlag, setWarningFlag] = useState(false)
  const [warningActive, setWarningActive] = useState(false)
  const [warningServiceFlag, setWarningServiceFlag] = useState(false)
  const warnEventUrl = window.location.origin + '/services/outageservice/api/warning-events'

  const sendGetRequest = async () => {
    try {
      const res = await axios.get(outageUrl)
      const events = res.data
      const now = moment().toDate()
      
      // Find any active outage that affects this service
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYDOJFINE') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.outageStart).toDate()
        const endDate = moment(event.outageEnd).toDate()
        const isDateInRange = now > startDate && now < endDate
        
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          setOutageStartDate(event.outageStart)
          setOutageEndDate(event.outageEnd)
          setOutageRichText(event.outageRichText)
          setOutageActive(true)
          setServiceFlag(true)
          setDateFlag(true)
          setDisableFlag(true)
          break // Found an active outage, no need to continue
        }
      }
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }

  const sendWarnGetRequest = async () => {
    try {
      const res = await axios.get(warnEventUrl)
      const events = res.data
      const now = moment().toDate()
      
      // Find any active warning that affects this service
      for (const event of events) {
        const services = event.services || ''
        const isServiceAffected = services.split(',').includes('PAYDOJFINE') || services.split(',').includes('ALLSERVICES')
        const startDate = moment(event.warningStartDate).toDate()
        const endDate = moment(event.warningEndDate).toDate()
        const isDateInRange = now > startDate && now < endDate
        
        if (event.enabled === true && isServiceAffected && isDateInRange) {
          setWarningStartDate(event.warningStartDate)
          setWarningEndDate(event.warningEndDate)
          setWarningRichText(event.warningMessageText)
          setWarningActive(true)
          setWarningServiceFlag(true)
          setWarningFlag(true)
          break // Found an active warning, no need to continue
        }
      }
    } catch (err) {
      // Handle Error Here
      console.error(err)
    }
  }

  useEffect(() => {
    sendGetRequest()
    sendWarnGetRequest()
  }, [])

  const momentOutageStartDate = moment(outageStartDate).toDate()
  const momentOutageEndDate = moment(outageEndDate).toDate()
  const momentWarningStartDate = moment(warningStartDate).toDate()
  const momentWarningEndDate = moment(warningEndDate).toDate()
  // console.log(momentOutageStartDate)
  // console.log(momentOutageEndDate)
  useEffect(() => {
    if (dateNow > momentOutageStartDate && dateNow < momentOutageEndDate) {
      setDateFlag(true)
    }
  }, [momentOutageStartDate, momentOutageEndDate])

  useEffect(() => {
    if (dateNow > momentWarningStartDate && dateNow < momentWarningEndDate) {
      setWarningFlag(true)
    }
  }, [momentWarningStartDate, momentWarningEndDate])

  useEffect(() => {
    if (dateFlag && serviceFlag && outageActive) {
      // flag = true
      setDisableFlag(true)
      // console.log(flag)
    }
  }, [dateFlag, serviceFlag, outageActive])

  useEffect(() => {
    try {
      dispatch(clearAllAction())
      dispatch(logoutAction()).catch((e) => {
        console.log(e)
      })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const checkCookiesEnabled = () => {
    try {
      var cookieEnabled = navigator.cookieEnabled
      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
        if (cookieEnabled) {
          return true
        } else {
          setErrMsg('privacy_notice.enable_cookies')
        }
      }
      return cookieEnabled
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const privacyNext = async () => {
    try {
      if (checkCookiesEnabled()) {
        dispatch(screenLoadingAction())
        dispatch(getServiceAvailableAction())
          .then((res) => {
            // if (true) {
            if (res['data']) {
              dispatch(registerAndLogin())
                .then(() => {
                  history.push(`/${i18n.language}${t('routes.fine_info')}`)
                  dispatch(screenLoadingAction())
                })
                .catch((e) => {
                  dispatch(screenLoadingAction())
                  console.log(e)
                  setErrMsg('privacy_notice.server_error')
                })
            } else {
              dispatch(screenLoadingAction())
              setErrMsg('privacy_notice.service_not_available_error')
            }
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('privacy_notice.service_not_available_error')
          })
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  let richTextMessage
  if (disableFlag === true) {
    richTextMessage = <div>{outageRichText}</div>
  }

  let warningRichTextMessage
  //set warning richTextMessage here if current date is between warning start and end date
  if (warningFlag === true) {
    warningRichTextMessage = <div>{warningRichText}</div>
  }

  function Banner() {
    if (disableFlag === true) {
      return (
        <div
          className="alert-medium"
          data-gtm-vis-first-on-screen-9622674_25="908"
          data-gtm-vis-total-visible-time-9622674_25="100"
          data-gtm-vis-has-fired-9622674_25="1"
          data-gtm-vis-first-on-screen-9622674_29="912"
          data-gtm-vis-total-visible-time-9622674_29="100"
          data-gtm-vis-has-fired-9622674_29="1"
        >
          <p className="no-margin">
            <span>{richTextMessage}</span>
          </p>
        </div>
      )
    }
    return null
  }

  function WarningBanner() {
    if (warningFlag === true && disableFlag === false && warningServiceFlag === true && warningActive === true) {
      return (
        <div
          className="alert-medium"
          data-gtm-vis-first-on-screen-9622674_25="908"
          data-gtm-vis-total-visible-time-9622674_25="100"
          data-gtm-vis-has-fired-9622674_25="1"
          data-gtm-vis-first-on-screen-9622674_29="912"
          data-gtm-vis-total-visible-time-9622674_29="100"
          data-gtm-vis-has-fired-9622674_29="1"
        >
          <p className="no-margin">
            <span>{warningRichTextMessage}</span>
          </p>
        </div>
      )
    }
    return null
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <Banner />
          <WarningBanner />
          <h2>{t('privacy_notice.page_title')}</h2>
          <p>
            {t('privacy_notice.para1')}
            <em>{t('privacy_notice.para1_freedom_of_info')}</em> {t('privacy_notice.para1_ou')}
            <em>{t('privacy_notice.para1_foipop')}</em>
            {t('privacy_notice.para1_other')}
          </p>
          <p>
            {t('privacy_notice.para2')}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === 'en' ? 'https://beta.novascotia.ca/privacy' : 'https://beta.novascotia.ca/fr/enonce-de-confidentialite'
              }
            >
              {t('privacy_notice.privacy_statement_link')}
              <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
            </a>
            {t('privacy_notice.para2_end')}
            {t('privacy_notice.para3')}
            <a href="mailto:askus@novascotia.ca">
              {t('privacy_notice.ask_novascotia')}
              <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
            </a>
            {t('privacy_notice.para3_end')}
          </p>
        </div>
      </div>
      <div className="form-group has-error">
        <button
          disabled={disableFlag}
          className="btn-lg btn-default"
          style={{ marginBottom: errMsg === '' ? '' : '5px' }}
          onClick={privacyNext}
          value={t('privacy_notice.continue')}
          name={t('privacy_notice.continue')}
        >
          {t('privacy_notice.continue')}
        </button>{' '}
        {errMsg === '' ? '' : <i className="fa fa-exclamation-circle" aria-hidden="true" />}
        <div className="help-block">{t(errMsg)}</div>
      </div>
    </div>
  )
}

export default withTranslation('common')(PrivacyNoticeView)
